/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ModalWindow from './modalWindow.component';

const mapStateToProps = (state, ownProps) => {
  return {
    isOpen: state.modal.isOpen,
    title: state.modal.props.title,
    subtitle: state.modal.props.subtitle,
    details: state.modal.props.details,
    className: state.modal.props.className,
    shouldCloseOnOverlayClick: state.modal.props.shouldCloseOnOverlayClick,
    id: ownProps.id
  };
};

const ModalWindowContainer = connect(mapStateToProps)(ModalWindow);

export default ModalWindowContainer;
